import { render, staticRenderFns } from "./activitytemplate.vue?vue&type=template&id=6e0cb904&scoped=true&"
import script from "./activitytemplate.vue?vue&type=script&lang=js&"
export * from "./activitytemplate.vue?vue&type=script&lang=js&"
import style0 from "./activitytemplate.vue?vue&type=style&index=0&id=6e0cb904&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0cb904",
  null
  
)

export default component.exports